import React from 'react';
import { useTranslation } from 'react-i18next';

function Cheap() {
    const { t } = useTranslation();
    return (
        <section className="">
            <div className="tf-container">
                <div className="row justify-content-center">

                    {/* Titre */}
                    <div className="col-md-12 text-center">
                        <div className="tf-heading my-5 wow fadeInUp">
                            <h2 className="heading" style={{ textAlign: "center" }}>
                                {t('Cheap FC Parts')}
                            </h2>
                        </div>
                    </div>

                    {/* Image - Centrée et en 8 colonnes */}
                    <div className="col-md-12 text-center" data-aos="fade-up" data-aos-duration="800">
                    <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("If you are looking for **the cheapest FC parts**, you are in the right place!")}
                            </p>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("We offer unbeatable prices without compromising on safety or delivery speed.")}
                            </p>
                    </div>

                    {/* Contenu long - Full width */}
                    <div className="col-md-12 mt-4">
                        <div className="content-box" style={{ padding: "20px", borderRadius: "10px", boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)" }}>
                            
                        <div className="content-box w-100" style={{ padding: "20px", borderRadius: "10px", boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)" }}>
                            <img 
                                src="images/pages/fc4.jpg" 
                                alt="Pièces FC pas chères" 
                                className="img-fluid" 
                                style={{ width: "100%", maxHeight: "500px", borderRadius: "8px" }} 
                            />
                        </div>
                            {/* <h3 className="content-title" style={{ fontSize: "20px", fontWeight: "600" }}>
                                {t('The best prices for FC parts')}
                            </h3> */}
                          

                            <h3 className="content-title" style={{ fontSize: "20px", fontWeight: "600" }}>
                                {t('Secure and reliable purchases')}
                            </h3>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("We guarantee **100% secure transactions**, ensuring your account remains protected at all times.")}
                            </p>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("Every transaction is handled with **advanced encryption** and **anti-fraud technology**.")}
                            </p>

                            <h3 className="content-title" style={{ fontSize: "20px", fontWeight: "600" }}>
                                {t('The fastest delivery on the market')}
                            </h3>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("Why wait hours when you can receive your parts **instantly**?")}
                            </p>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("Our **24/7 delivery system** operates continuously, ensuring immediate receipt.")}
                            </p>

                            <h3 className="content-title" style={{ fontSize: "20px", fontWeight: "600" }}>
                                {t('Exclusive promotions and discounts')}
                            </h3>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("We regularly offer **discounts, promo codes, and special offers**.")}
                            </p>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("Don't miss our offers during **Black Friday, Cyber Monday, and special events**!")}
                            </p>

                            <h3 className="content-title" style={{ fontSize: "20px", fontWeight: "600" }}>
                                {t('24/7 customer support')}
                            </h3>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("Questions? Need help with your order?")}
                            </p>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("Our **support team is available 24/7** via **live chat, email, or phone**.")}
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}

export default Cheap;
